interface FeedbackDisplayProps {
  message: string;
  type: 'correct' | 'wrong' | '';
}

export default function FeedbackDisplay({ message, type }: FeedbackDisplayProps) {
  return (
    <div className={`quiz-feedback${type ? ' ' + type : ''}`}>
      {message}
    </div>
  );
}
